<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-btn flat slot="activator">
      <v-icon color="red">warning</v-icon>
    </v-btn>
    <v-card color="red accent-2">
      <v-card-title>
        <h2>Attenzione!</h2>
      </v-card-title>
      <v-card-text>
        <v-alert
          :value="true"
          color="error"
          icon="warning"
        >Non sarà possibile effettuare l'iscrizione ad alcun corso finchè l'amministratore non darà l'autorizzazione per questo account!</v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false
  })
};
</script>

<style scoped>
</style>
